import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CategoryIcon from '@mui/icons-material/Category';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Groups3Icon from '@mui/icons-material/Groups3';
import HomeIcon from '@mui/icons-material/Home';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import InventoryIcon from '@mui/icons-material/Inventory';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LogoutIcon from '@mui/icons-material/Logout';
import Person3Icon from '@mui/icons-material/Person3';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import ConfirmationDialog from './ConfirmationDialog';

const Sidebar = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(null);
  const [logoutDialog, setLogoutDialog] = useState(false);

  const sidebarData = [
    {
      name: 'Dashboard',
      link: '/myAccount/dashboard',
      icon: <DashboardIcon />,
    },
    { name: 'Orders', link: '/myAccount/orders', icon: <ListAltIcon /> },
    {
      name: 'Account Details',
      link: '/myAccount/accountDetails',
      icon: <AccountCircleIcon />,
    },
  ];

  if (user?.role === 'admin') {
    sidebarData.push(
      { name: 'Seller', link: '/myAccount/seller', icon: <Person3Icon /> },
      { name: 'Buyers', link: '/myAccount/buyers', icon: <Groups3Icon /> },
      {
        name: 'Category',
        link: '/myAccount/addcategory',
        icon: <CategoryIcon />,
        item: 'Category',
      },
      { name: 'Home Slide', link: '/myAccount/homeSlide', icon: <HomeIcon /> },
      {
        name: 'Entrepreneurs Details',
        link: '/myAccount/clientsDetails',
        icon: <HandshakeIcon />,
      },
      {
        name: 'Products',
        link: '/myAccount/addproducts',
        icon: <InventoryIcon />,
        item: 'Products',
      }
    );
  }

  if (user?.role === 'seller') {
    sidebarData.push(
      {
        name: 'Products',
        link: '/myAccount/addproducts',
        icon: <InventoryIcon />,
        item: 'Products',
      },
      {
        name: 'Address',
        link: '/myAccount/address',
        icon: <AddHomeWorkIcon />,
        item: 'Address',
      }
    );
  }

  if (user?.role === 'buyer') {
    sidebarData.push(
      // {
      //   name: 'Products',
      //   link: '/myAccount/addproducts',
      //   icon: <InventoryIcon />,
      //   item: 'Products',
      // },
      {
        name: 'Address',
        link: '/myAccount/address',
        icon: <AddHomeWorkIcon />,
        item: 'Address',
      }
    );
  }

  const logoutItem = {
    name: 'Logout',
    link: '/account',
    icon: <LogoutIcon />,
    action: () => setLogoutDialog(true),
  };

  const logoutSubmit = () => {
    setLogoutDialog(false);
    localStorage.clear();
    sessionStorage.clear();
    navigate('/account');
  };

  const handleClose = () => {
    setLogoutDialog(false);
  };

  return (
    <>
      <ul className='sidebar'>
        {sidebarData.map((sidebar, index) => (
          <li
            key={index}
            onMouseEnter={() => setIsHovered(index)}
            onMouseLeave={() => setIsHovered(null)}
            className={`sidebar-item ${isHovered === index ? 'hovered' : ''}`}
          >
            <NavLink
              to={sidebar.link}
              className='sidebar-link'
              data-text={sidebar.name}
              onClick={(event) => {
                if (sidebar.action) {
                  event.preventDefault();
                  sidebar.action();
                }
              }}
            >
              <IconButton className='icon-button'>{sidebar.icon}</IconButton>
              <span className='ms-3'>{sidebar.name}</span>
            </NavLink>
          </li>
        ))}

        <li
          onMouseEnter={() => setIsHovered('logout')}
          onMouseLeave={() => setIsHovered(null)}
          className={`sidebar-item ${isHovered === 'logout' ? 'hovered' : ''}`}
        >
          <NavLink
            to={logoutItem.link}
            className='sidebar-link'
            data-text={logoutItem.name}
            onClick={(event) => {
              event.preventDefault();
              logoutItem.action();
            }}
          >
            <IconButton className='icon-button'>{logoutItem.icon}</IconButton>
            <span className='ms-3'>{logoutItem.name}</span>
          </NavLink>
        </li>
      </ul>

      <ConfirmationDialog
        open={logoutDialog}
        onClose={handleClose}
        onConfirm={logoutSubmit}
        title='Logout'
        description='Are you sure you want to Logout?'
      />
    </>
  );
};

export default Sidebar;
